module.exports = __webpack_public_path__ + "img/79.274b8162.jpg";